module.exports = __WEBPACK_EXTERNAL_MODULE_46__;


//////////////////
// WEBPACK FOOTER
// external {"root":"angularDraggableDroppable","commonjs":"angular-draggable-droppable","commonjs2":"angular-draggable-droppable"}
// module id = 46
// module chunks = 0